// uat
import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Layout from "./Layout";
import { useSessionKey } from '../context/SessionKeyContext';

import { useBackground } from '../context/BackgroundContext';
// import loginBgDesktop from '../assets/login_page_4k.jpg';
// import loginBgMobile from '../assets/login_phone.jpg'; 
import loginBgDesktop from '../assets/login_page_4k_latest.jpg';
import loginBgMobile from '../assets/login_phone_long.jpg'; 
import './LoginPage.css';
import { encryptAES, decryptAES } from "../utils/cryptoUtils";
import { useAuth } from "../context/AuthContext";
import { fetchInitialJwt, createApiClient } from '../utils/api';

const sitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY_LOCAL;
const IS_DOMAIN_2 = 
  window.location.hostname === "aspire-uat.iciciprulife.com" ||  // For production
  window.location.host === "localhost:3001";     // For local testing


  const LoginPage = () => {

    const { apiJwt, setApiJwt } = useAuth();  
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { setKey, sessionKey, loadingKey } = useSessionKey();
  const navigate = useNavigate();
  const { changeBackground } = useBackground();

  useEffect(() => {
    changeBackground(loginBgDesktop);
  }, [changeBackground]);

  useEffect(() => {
    if (!loadingKey && sessionKey) {
      navigate('/user-details');
    }
  }, [sessionKey, loadingKey, navigate]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
  changeBackground(isMobile ? loginBgMobile : loginBgDesktop);
}, [changeBackground, isMobile]);


  const onRecaptchaChange = (token) => setRecaptchaToken(token);
  const onRecaptchaExpired = () => {
    setRecaptchaToken(null);
    setError("reCAPTCHA expired. Please re-verify.");
  };

  const unwrap = (p) => JSON.parse(decryptAES(p.encryptedResponse));

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!recaptchaToken || !/^\d{10,15}$/.test(phoneNumber.trim())) {
      setError("Please complete reCAPTCHA and enter a valid WhatsApp number.");
      setLoading(false);
      return;
    }

    try {
            const initialToken = await fetchInitialJwt();
            const tempApiClient = createApiClient(initialToken);
            const payload = {
              step : "otp_request",
              whatsapp_number: phoneNumber,
              recaptcha_token: recaptchaToken,
            };
      
            // Only add domain/referral info if on Domain 2
            if (IS_DOMAIN_2) {
              payload.source_domain = "domain2";
            }

            const encryptedPayload = encryptAES(
              JSON.stringify(payload)
            );
            
            // uat
            // const response = await tempApiClient.post(
            //   "https://api-uat.iciciprulife.com/biu/aspireai/otp/request",
            //   { encryptedRequest: encryptedPayload }
            // );

            // prod
            const response = await tempApiClient.post(
              "https://api.iciciprulife.com/biu/aspireai/otp/request",
              { encryptedRequest: encryptedPayload }
            );
            
            const data = await response.json(); 
            const result = unwrap(data);
      
            setOtpSent(true);
            setSessionId(result.session_challenge_id);
            
            if (result.token) {
              setApiJwt(result.token);
              console.log("New API JWT has been set globally.");
              setError("");
              alert("OTP sent to your WhatsApp number!");
            } else {
                const errorResult = unwrap(data);
                setError(errorResult.error || errorResult.message || "OTP verification failed.");
            }
      
          } catch (err) {
            console.error("Error sending OTP:", err);
            setError(err.message || "Network error. Please try again.");
            setRecaptchaToken(null);
          } finally {
            setLoading(false);
          }
        };
      
        const handleVerifyOtp = async (e) => {
          e.preventDefault();
          setError("");
          setLoading(true);
      
          try {
            const encryptedPayload = encryptAES(
              JSON.stringify({
                session_challenge_id: sessionId,
                otp: otp,
                whatsapp_number: phoneNumber,
                nonce: crypto.randomUUID(),
              })
            );
      
            const apiClient = createApiClient(apiJwt);
            
            //uat
            // const response = await apiClient.post('https://api-uat.iciciprulife.com/biu/aspireai/verify/otp', {
            //   encryptedRequest: encryptedPayload,
            // });

            //prod
            const response = await apiClient.post('https://api.iciciprulife.com/biu/aspireai/verify/otp', {
              encryptedRequest: encryptedPayload,
            });
      
            if (response.ok) {
              setKey(sessionId);
              const data = await response.json();
              const result = unwrap(data);
              alert("Login successful!");
              navigate('/user-details');
            } else {
              const data = await response.json();
              const errorResult = unwrap(data);
              setError(errorResult.error || errorResult.message || "OTP verification failed.");
            }
          } catch (err) {
            console.error("Network error verifying OTP:", err);
            setError("Network error. Please try again.");
          } finally {
            setLoading(false);
          }
        };


  return (
          <Layout>
              <div className="login-container">
                  <div className="login-card">
                      <h2>Login with WhatsApp</h2>
                      {error && <p className="error-message">{error}</p>}
    
                      {!otpSent ? (
                          <>
                              <p>Please complete reCAPTCHA and enter your WhatsApp number.</p>
                              <div className="recaptcha-wrapper">
                              <ReCAPTCHA
                                    sitekey = {sitekey}
                                    onChange={onRecaptchaChange}
                                    onExpired={onRecaptchaExpired}
                              />
                              </div>
                              <form onSubmit={handleSendOtp}>
                                  <div className="form-group">
                                      <label htmlFor="whatsapp_number">WhatsApp Number:</label>
                                      <input
                                          type="tel" /* CHANGED: triggers numeric keypad on mobile */
                                          inputMode="numeric" /* CHANGED: helps strict numeric keyboards */
                                          id="whatsapp_number"
                                          value={phoneNumber}
                                          onChange={(e) => setPhoneNumber(e.target.value)}
                                          placeholder="e.g., 9876543210"
                                          maxLength="10"
                                          disabled={!recaptchaToken || loading}
                                          required
                                          // autoComplete="tel" /* Helps browsers autofill phone numbers */
                                      />
                                  </div>
                                  <button type="submit" disabled={!recaptchaToken || loading}>
                                      {loading ? 'Sending OTP...' : 'Send OTP'}
                                  </button>
                              </form>
                          </>
                      ) : (
                          <form onSubmit={handleVerifyOtp}>
                              <p>An OTP has been sent to {phoneNumber}.</p>
                              <div className="form-group">
                                  <label htmlFor="otp">Enter OTP:</label>
                                  <input
                                      type="text"
                                      inputMode="numeric" /* Triggers numeric keyboard */
                                      pattern="[0-9]*" /* Ensures only numbers for iOS */
                                      id="otp"
                                      value={otp}
                                      onChange={(e) => setOtp(e.target.value)}
                                      placeholder="6-digit OTP"
                                      maxLength="6"
                                      disabled={loading}
                                      required
                                      autoComplete="one-time-code" /* iOS/Android feature to auto-fill SMS code */
                                  />
                              </div>
                              <button type="submit" disabled={loading}>
                                  {loading ? 'Verifying...' : 'Verify OTP'}
                              </button>
                          </form>
                      )}
                  </div>
              </div>
          </Layout>
      );
    };
    
    export default LoginPage;







// Local Testing: Recaptcha v2
// import React, { useState, useEffect } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import ReCAPTCHA from "react-google-recaptcha";
// import Layout from "./Layout";
// import { useBackground } from '../context/BackgroundContext';
// import loginBgDesktop from '../assets/login_page_4k_latest.jpg';
// import loginBgMobile from '../assets/login_phone_long.jpg'; 
// import './LoginPage.css';

// const sitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY_LOCAL;

// const LoginPage = () => {
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [sessionId, setSessionId] = useState(null);
//   const [recaptchaToken, setRecaptchaToken] = useState(null);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const navigate = useNavigate();
//   const { changeBackground } = useBackground();

//   useEffect(() => {
//     changeBackground(loginBgDesktop);
//   }, [changeBackground]);

//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

//   useEffect(() => {
//   const handleResize = () => {
//     setIsMobile(window.innerWidth <= 600);
//   };

//   window.addEventListener("resize", handleResize);
//   return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//   changeBackground(isMobile ? loginBgMobile : loginBgDesktop);
// }, [changeBackground, isMobile]);


//   const onRecaptchaChange = (token) => setRecaptchaToken(token);
//   const onRecaptchaExpired = () => {
//     setRecaptchaToken(null);
//     setError("reCAPTCHA expired. Please re-verify.");
//   };


//   const handleSendOtp = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     if (!recaptchaToken || !/^\d{10,15}$/.test(phoneNumber.trim())) {
//       setError("Please complete reCAPTCHA and enter a valid WhatsApp number.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const payload = {
//         step: "otp_request",
//         whatsapp_number: phoneNumber,
//         recaptcha_token: recaptchaToken,
//       };

//       try {
//         const response = await fetch("http://127.0.0.1:8028/aspireai/otp_request", {
//           credentials: "include",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             // 'X-Access-Key': sessionKey,
//           },
//           body: JSON.stringify(payload),
//         });
//         const data = await response.json();
        
//         // Need to fix this
//         if (data.error) {
//           alert(`Error: ${data.error}`);
//           setError(data.error);
//           setRecaptchaToken(null);
//         } 
//         else{
//           setOtpSent(true);
//           setSessionId(data.session_challenge_id);
//           setError("");
//           alert("OTP sent to your WhatsApp number!");
//         }

//       } catch (error) {
//         console.error("Error submitting details:", error);
//         alert("Failed to submit details.");
//       }
//     } catch (err) {
//       console.error("Error sending OTP:", err);
//       setError(err.message || "Network error. Please try again.");
//       setRecaptchaToken(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyOtp = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     const payload2 = {
//           session_challenge_id: sessionId,
//           otp: otp,
//           whatsapp_number: phoneNumber,
//           nonce: crypto.randomUUID(),
//     };

//     try {
//       const response = await fetch("http://127.0.0.1:8028/aspireai/verify_otp", {
//         credentials: "include",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           // 'X-Access-Key': sessionKey,
//         },
//         body: JSON.stringify(payload2),
//       });
//       const result = await response.json();

//       if (response.error) {
//         alert(`Error: ${response.error}`);
//       } 
//       else {
//         alert("Login successful!");
//         navigate('/user-details');
//       }

//     } catch (err) {
//       console.error("Error verifying OTP:", err);
//       setError(err.message || "Network error. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//           <Layout>
//               <div className="login-container">
//                   <div className="login-card">
//                       <h2>Login with WhatsApp</h2>
//                       {error && <p className="error-message">{error}</p>}
    
//                       {!otpSent ? (
//                           <>
//                               <p>Please complete reCAPTCHA and enter your WhatsApp number.</p>
//                               <div className="recaptcha-wrapper">
//                               <ReCAPTCHA
//                                     sitekey = {sitekey}
//                                     onChange={onRecaptchaChange}
//                                     onExpired={onRecaptchaExpired}
//                               />
//                               </div>
//                               <form onSubmit={handleSendOtp}>
//                                   <div className="form-group">
//                                       <label htmlFor="whatsapp_number">WhatsApp Number:</label>
//                                       <input
//                                           type="tel" /* CHANGED: triggers numeric keypad on mobile */
//                                           inputMode="numeric" /* CHANGED: helps strict numeric keyboards */
//                                           id="whatsapp_number"
//                                           value={phoneNumber}
//                                           onChange={(e) => setPhoneNumber(e.target.value)}
//                                           placeholder="e.g., 9876543210"
//                                           maxLength="10"
//                                           disabled={!recaptchaToken || loading}
//                                           required
//                                           // autoComplete="tel" /* Helps browsers autofill phone numbers */
//                                       />
//                                   </div>
//                                   <button type="submit" disabled={!recaptchaToken || loading}>
//                                       {loading ? 'Sending OTP...' : 'Send OTP'}
//                                   </button>
//                               </form>
//                           </>
//                       ) : (
//                           <form onSubmit={handleVerifyOtp}>
//                               <p>An OTP has been sent to {phoneNumber}.</p>
//                               <div className="form-group">
//                                   <label htmlFor="otp">Enter OTP:</label>
//                                   <input
//                                       type="text"
//                                       inputMode="numeric" /* Triggers numeric keyboard */
//                                       pattern="[0-9]*" /* Ensures only numbers for iOS */
//                                       id="otp"
//                                       value={otp}
//                                       onChange={(e) => setOtp(e.target.value)}
//                                       placeholder="6-digit OTP"
//                                       maxLength="6"
//                                       disabled={loading}
//                                       required
//                                       autoComplete="one-time-code" /* iOS/Android feature to auto-fill SMS code */
//                                   />
//                               </div>
//                               <button type="submit" disabled={loading}>
//                                   {loading ? 'Verifying...' : 'Verify OTP'}
//                               </button>
//                           </form>
//                       )}
//                   </div>
//               </div>
//           </Layout>
//       );
//     };
    
//     export default LoginPage;


// import React, { useState, useEffect } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";
// // 1. Import the v3 hook
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
// import Layout from "./Layout";
// import { useBackground } from '../context/BackgroundContext';
// import loginBgDesktop from '../assets/login_page_4k.jpg';
// import loginBgMobile from '../assets/login_phone.jpg'; 
// import './LoginPage.css';

// const LoginPage = () => {
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [sessionId, setSessionId] = useState(null);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const navigate = useNavigate();
//   const { changeBackground } = useBackground();
  
//   // 2. Initialize the hook
//   const { executeRecaptcha } = useGoogleReCaptcha();

//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 600);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     changeBackground(isMobile ? loginBgMobile : loginBgDesktop);
//   }, [changeBackground, isMobile]);

//   const handleSendOtp = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     if (!/^\d{10,15}$/.test(phoneNumber.trim())) {
//       setError("Please enter a valid WhatsApp number.");
//       setLoading(false);
//       return;
//     }

//     // 3. Ensure ReCAPTCHA is loaded before executing
//     if (!executeRecaptcha) {
//       setError("reCAPTCHA is not ready. Please try again.");
//       setLoading(false);
//       return;
//     }

//     try {
//       // 4. Generate the token dynamically at the time of the request
//       const token = await executeRecaptcha("otp_request");

//       const payload = {
//         step: "otp_request",
//         whatsapp_number: phoneNumber,
//         recaptcha_token: token, // Send the v3 token to your backend
//       };

//       const response = await fetch("http://127.0.0.1:8028/aspireai/otp_request", {
//         credentials: "include",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });
//       const data = await response.json();
      
//       if (data.error) {
//         alert(`Error: ${data.error}`);
//         setError(data.error);
//       } else {
//         setOtpSent(true);
//         setSessionId(data.session_challenge_id);
//         setError("");
//         alert("OTP sent to your WhatsApp number!");
//       }
//     } catch (err) {
//       console.error("Error sending OTP:", err);
//       setError(err.message || "Network error. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyOtp = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     const payload2 = {
//       session_challenge_id: sessionId,
//       otp: otp,
//       whatsapp_number: phoneNumber,
//       nonce: crypto.randomUUID(),
//     };

//     try {
//       const response = await fetch("http://127.0.0.1:8028/aspireai/verify_otp", {
//         credentials: "include",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload2),
//       });
//       const result = await response.json();

//       if (result.error) {
//         alert(`Error: ${result.error}`);
//         setError(result.error);
//       } else {
//         alert("Login successful!");
//         navigate('/user-details');
//       }
//     } catch (err) {
//       console.error("Error verifying OTP:", err);
//       setError(err.message || "Network error. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Layout>
//       <div className="login-container">
//         <div className="login-card">
//           <h2>Login with WhatsApp</h2>
//           {error && <p className="error-message">{}</p>}

//           {!otpSent ? (
//             <>
//               {/* Note: The physical captcha UI is entirely removed */}
//               <p>Please enter your WhatsApp number.</p>
              
//               <form onSubmit={handleSendOtp}>
//                 <div className="form-group">
//                   <label htmlFor="whatsapp_number">WhatsApp Number:</label>
//                   <input
//                     type="tel"
//                     inputMode="numeric"
//                     id="whatsapp_number"
//                     value={phoneNumber}
//                     onChange={(e) => setPhoneNumber(e.target.value)}
//                     placeholder="e.g., 9876543210"
//                     maxLength="10"
//                     disabled={loading}
//                     required
//                   />
//                 </div>
//                 <button type="submit" disabled={loading}>
//                   {loading ? 'Sending OTP...' : 'Send OTP'}
//                 </button>
//               </form>
//             </>
//           ) : (
//             <form onSubmit={handleVerifyOtp}>
//               <p>An OTP has been sent to {phoneNumber}.</p>
//               <div className="form-group">
//                 <label htmlFor="otp">Enter OTP:</label>
//                 <input
//                   type="text"
//                   inputMode="numeric"
//                   pattern="[0-9]*"
//                   id="otp"
//                   value={otp}
//                   onChange={(e) => setOtp(e.target.value)}
//                   placeholder="6-digit OTP"
//                   maxLength="6"
//                   disabled={loading}
//                   required
//                   autoComplete="one-time-code"
//                 />
//               </div>
//               <button type="submit" disabled={loading}>
//                 {loading ? 'Verifying...' : 'Verify OTP'}
//               </button>
//             </form>
//           )}
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default LoginPage;